import type { MediaFolder } from "@ckgo2/shared/types";
import i18n from "@/i18n";

/** Human-readable file size (B / KB / MB). */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Localized display label for a media type-category folder. The folder value
 * itself stays the raw enum sent to the API — only the label is translated.
 */
export function mediaFolderLabel(folder: MediaFolder): string {
  const labels: Record<MediaFolder, string> = {
    destinations: i18n.t("media.folders.destinations"),
    trips: i18n.t("media.folders.trips"),
    activities: i18n.t("media.folders.activities"),
    guides: i18n.t("media.folders.guides"),
    blog: i18n.t("media.folders.blog"),
    teams: i18n.t("media.folders.teams"),
    general: i18n.t("media.folders.general"),
    "departure-photos": i18n.t("media.folders.departurePhotos"),
  };
  return labels[folder];
}
